import { ButtonTriggerEvent } from '../../../common/components';
import { Account } from '../../../models/admin/account';

export class AddSpiderEventsModalActions {
    confirm: (event: ButtonTriggerEvent) => void;
    cancel?: () => void;
}

export class AddSpiderEventsModalData {
    constructor(hubName, accounts, events, socialName, isTest = false) {
        this.events = events;
        this.accounts = accounts;
        this.hubName = hubName;
        this.socialName = socialName;
        this.isTest = isTest;
    }
    accounts: Account[];
    events: any[];
    hubName: string;
    socialName: string;
    isTest: boolean;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/add.spider.events.modal/add.spider.events.modal.provider.ts